import React from 'react';

import { KeyOutlined, ApiOutlined, UserOutlined } from '@ant-design/icons';
import { Form, Input, Row, Col } from 'antd';
import { useTranslation } from 'react-i18next';

import { useDirtyMaskedField } from '@hooks/shared/useDirtyMaskedField';

const WoocommerceCredentials = ({ form, ecAccount }) => {
  const { t } = useTranslation();

  const isEditing = !!ecAccount?.id;
  const apiKeyDirty = useDirtyMaskedField(form, [ 'credentials', 'api_key' ], isEditing);

  return (
    <div>
      <Row gutter={16}>
        <Col span={12}>
          <Form.Item
            name={['credentials', 'api_domain']}
            label={t('models.ec_account.platform_settings.woocommerce.api_domain')}
            rules={[{ required: true, message: t('models.ec_account.platform_settings.woocommerce.api_domain_required') }]}
          >
            <Input
              placeholder={t('models.ec_account.platform_settings.woocommerce.api_domain_placeholder')}
              prefix={<ApiOutlined />}
            />
          </Form.Item>
        </Col>

        <Col span={12}>
          <Form.Item
            name={['credentials', 'api_username']}
            label={t('models.ec_account.platform_settings.woocommerce.api_username')}
            rules={[{ required: true, message: t('models.ec_account.platform_settings.woocommerce.api_username_required') }]}
          >
            <Input
              placeholder={t('models.ec_account.platform_settings.woocommerce.api_username_placeholder')}
              prefix={<UserOutlined />}
            />
          </Form.Item>
        </Col>

        <Col span={12}>
          <Form.Item
            name={['credentials', 'api_key']}
            label={t('models.ec_account.platform_settings.woocommerce.api_key')}
            rules={[{ required: true, message: t('models.ec_account.platform_settings.woocommerce.api_key_required') }]}
            extra={t('models.ec_account.platform_settings.woocommerce.permission_hint')}
          >
            <Input.Password
              autoComplete="new-password"
              placeholder={t('models.ec_account.platform_settings.woocommerce.api_key_placeholder')}
              prefix={<KeyOutlined />}
              visibilityToggle={apiKeyDirty}
            />
          </Form.Item>
        </Col>
      </Row>
    </div>
  );
};

export default WoocommerceCredentials;
